import { AppleLogoIcon, GooglePlayIcon } from "./StoreIcons";

const APP_STORE_URL =
  "https://apps.apple.com/fr/app/lift-ai-am%C3%A9liore-ton-physique/id6769496917";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.rork.liftaiandroid";

const baseClasses =
  "group inline-flex items-center gap-3.5 px-5 py-3 rounded-2xl border backdrop-blur-md transition-all duration-300 hover:-translate-y-0.5";

const variants = {
  light: {
    // For dark backgrounds (footer, dark hero)
    button:
      "border-white/15 bg-white/5 text-white hover:bg-white/10 hover:border-white/30",
    caption: "text-white/70",
    label: "text-white",
  },
  dark: {
    // For light backgrounds (hero on white)
    button:
      "border-neutral-950/15 bg-neutral-950/[0.03] text-neutral-950 hover:bg-neutral-950/[0.06] hover:border-neutral-950/30",
    caption: "text-neutral-500",
    label: "text-neutral-950",
  },
};

export function AppStoreButton({ variant = "dark", testId = "app-store-button" }) {
  const v = variants[variant];
  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`${baseClasses} ${v.button}`}
    >
      <AppleLogoIcon className="w-7 h-7 flex-shrink-0" />
      <div className="flex flex-col items-start leading-tight text-left">
        <span className={`text-[11px] ${v.caption}`}>Télécharger sur</span>
        <span className={`text-lg font-semibold tracking-tight ${v.label}`}>
          App Store
        </span>
      </div>
    </a>
  );
}

export function PlayStoreButton({ variant = "dark", testId = "play-store-button" }) {
  const v = variants[variant];
  return (
    <a
      href={PLAY_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`${baseClasses} ${v.button}`}
    >
      <GooglePlayIcon className="w-7 h-7 flex-shrink-0" />
      <div className="flex flex-col items-start leading-tight text-left">
        <span className={`text-[11px] ${v.caption}`}>Télécharger sur</span>
        <span className={`text-lg font-semibold tracking-tight ${v.label}`}>
          Google Play
        </span>
      </div>
    </a>
  );
}
